import { render, staticRenderFns } from "./showGetfree.vue?vue&type=template&id=2bc12b06&scoped=true"
import script from "./showGetfree.vue?vue&type=script&lang=js"
export * from "./showGetfree.vue?vue&type=script&lang=js"
import style0 from "./showGetfree.vue?vue&type=style&index=0&id=2bc12b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc12b06",
  null
  
)

export default component.exports